// src/pages/ViewRewardedIdea.js
import React from "react";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import "./ViewRewardedIdea.css";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Zoom from 'react-medium-image-zoom'; // ✅ import zoom
import 'react-medium-image-zoom/dist/styles.css'; // ✅ import zoom CSS

const ViewRewardedIdea = () => {
  const location = useLocation();
  const idea = location.state?.idea;

  const [showPopup, setShowPopup] = useState(false); // ✅ NEW
const navigate = useNavigate();
  if (!idea) {
    return <div className="error-msg">Idea not found.</div>;
  }


  return (
    <div className="view-idea-page">
<div className="idea-header">
        <FaArrowLeft className="back" onClick={() => navigate(-1)} />

  <div className="left-section">

    <div className="profile-wrapper">
      {idea.profileImageUrl ? (
        <img
          src={idea.profileImageUrl}
          alt={idea.authorName}
          className="profile-image"
          loading="lazy"
        />
      ) : (
        <span className="avatar">{idea.authorName?.[0]}</span>
      )}
    </div>
    <span className="user-name">{idea.authorName}</span>
  </div>

  <div className="right-section">
    <span className="reward">🏅 INR {idea.reward}</span>
  </div>
</div>
        <p className="preview-title">{idea.title}</p>

      {idea.imageUrl && (
        <img src={idea.imageUrl} className="preview-image" alt="idea"             style={{ cursor: "pointer" }}
            onClick={() => setShowPopup(true)} // ✅ NEW
/>
      )}

      <div className="idea-tags">
        {idea.tags?.map((tag, i) => (
          <span className="tag" key={i}>{tag}</span>
        ))}
      </div>

      <p className="idea-description">{idea.description}</p>

     {showPopup && (
  <div className="popup-overlay">
    <div className="popup-close" onClick={() => setShowPopup(false)}>
      &times;
    </div>
    <div className="image-popup">
      <Zoom>
        <img
          src={idea.imageUrl}
          alt="Zoomed Preview"
          style={{ width: "100%", height: "auto", borderRadius: "20px" }}
        />
      </Zoom>
    </div>
  </div>
)}

    </div>
  );
};

export default ViewRewardedIdea;